// extracted by mini-css-extract-plugin
export default {"details":"Details_details__5fLt4"};